"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_1 = require("react-router");
var __1 = require("../..");
var either_1 = require("../../utils/either");
var utils_1 = require("../utils/utils");
var UdalostDetailPage_1 = __importDefault(require("./UdalostDetailPage"));
var utils_2 = require("./utils");
var getTypNazev = function (typ) {
    if (typ.id === __1.TypyUdalosti.KontrolaZapisuZnalce)
        return 'Kontrola zápisu údajů do Seznamu znalců v uplynulém roce';
    if (typ.id === __1.TypyUdalosti.KontrolaZapisuTlumocnika)
        return 'Kontrola zápisu údajů do Seznamu tlumočníků v uplynulém roce';
    if (typ.id === __1.TypyUdalosti.KontrolaNevlozeniProfesnihoPojisteni)
        return 'Nedoložení dokladu profesního pojištění v uvedeném termínu';
    if (typ.id === __1.TypyUdalosti.KontrolaPosudkuZnalce)
        return 'Kontrola počtu posudků znalce';
    if (typ.id === __1.TypyUdalosti.KontrolaUkonuTlumocnika)
        return 'Kontrola počtu úkonů tlumočníka/překladatele';
    return typ === null || typ === void 0 ? void 0 : typ.nazev;
};
var InfoDetailUkoluPage = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var ukol = _a.ukol, onClose = _a.onClose, sendingZobrazeno = _a.sendingZobrazeno;
    var history = react_router_1.useHistory();
    var zasobnikUrl = __1.useConfig().zasobnikUrl;
    var postSetDokonceno = __1.usePostJSON(zasobnikUrl + "/SetDokonceno");
    var postSetZobrazeno = __1.usePostJSON(zasobnikUrl + "/SetZobrazeno");
    var isLoadingSave = __1.useBoolean(false);
    var isOpen = __1.useBoolean(true);
    var subjekty = ukol === null || ukol === void 0 ? void 0 : ukol.subjekt;
    var pojisteni = ((_b = ukol === null || ukol === void 0 ? void 0 : ukol.typ) === null || _b === void 0 ? void 0 : _b.id) === __1.TypyUdalosti.KontrolaNevlozeniProfesnihoPojisteni || ((_c = ukol === null || ukol === void 0 ? void 0 : ukol.typ) === null || _c === void 0 ? void 0 : _c.id) === __1.TypyUdalosti.KontrolaPovinnostiDolozitPojisteni;
    var posudek = ((_d = ukol === null || ukol === void 0 ? void 0 : ukol.typ) === null || _d === void 0 ? void 0 : _d.id) === __1.TypyUdalosti.KontrolaTerminuPosudku;
    var ukon = ((_e = ukol === null || ukol === void 0 ? void 0 : ukol.typ) === null || _e === void 0 ? void 0 : _e.id) === __1.TypyUdalosti.KontrolaTerminuUkonu;
    var _m = react_1.useState(), errorMessage = _m[0], setErrorMessage = _m[1];
    var handleClose = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (ukol === null || ukol === void 0 ? void 0 : ukol.zobrazitUzivateli) {
                isLoadingSave.setTrue();
                if (sendingZobrazeno)
                    postSetZobrazeno({ IdUdalost: ukol === null || ukol === void 0 ? void 0 : ukol.id });
                isLoadingSave.setFalse();
            }
            if (onClose)
                onClose();
            return [2 /*return*/];
        });
    }); };
    var handleDokonceno = function () { return __awaiter(void 0, void 0, void 0, function () {
        var update;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isLoadingSave.setTrue();
                    if ((ukol === null || ukol === void 0 ? void 0 : ukol.zobrazitUzivateli) && sendingZobrazeno)
                        postSetZobrazeno({ IdUdalost: ukol === null || ukol === void 0 ? void 0 : ukol.id });
                    return [4 /*yield*/, postSetDokonceno({ IdUdalost: ukol === null || ukol === void 0 ? void 0 : ukol.id })];
                case 1:
                    update = _a.sent();
                    isLoadingSave.setFalse();
                    if (either_1.isRight(update)) {
                        if (onClose)
                            onClose(true);
                        else
                            isOpen.setFalse();
                    }
                    else
                        setErrorMessage(update.value.message);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(utils_2.StyledPopup, { open: isOpen.value, onClose: function () { return handleClose(); }, onClickClose: function () { return isOpen.setFalse(); } }, ukol && (react_1.default.createElement(utils_2.DetailBody, null,
        react_1.default.createElement(utils_2.StyledHeader, null, getTypNazev(ukol.typ)),
        errorMessage && (react_1.default.createElement(__1.Message, { type: "error", onClose: function () { return setErrorMessage(undefined); } }, errorMessage)),
        react_1.default.createElement(utils_2.StyledUdalostListItem, null,
            react_1.default.createElement(utils_2.StyledLabel, { type: "grey" }, "Informativn\u00ED"),
            react_1.default.createElement("div", null, utils_2.getStavUkolu(ukol.stav))),
        react_1.default.createElement(utils_2.SubjektBody, null,
            react_1.default.createElement(utils_2.StyledSpan, null, "Subjekt"),
            react_1.default.createElement("div", null, subjekty === null || subjekty === void 0 ? void 0 : subjekty.map(function (s) { return (react_1.default.createElement(utils_2.StyledDiv, { key: "ukol-subjekt-" + s.id },
                react_1.default.createElement(__1.LinkButton, { onClick: function () { return history.push(utils_2.getSubjektLink(s)); } }, utils_2.getJmenoNazevSubjektu(s)),
                react_1.default.createElement("div", null, s.druhOsoba))); }))),
        (ukon || posudek) && (react_1.default.createElement(utils_2.SubjektBody, null,
            react_1.default.createElement(utils_2.StyledSpan, null, posudek ? 'Posudek' : 'Úkon'),
            react_1.default.createElement(__1.LinkButton, { onClick: function () { return history.push("/evidence-" + (posudek ? 'posudku' : 'ukonu') + "/detail/" + ukol.ukon.idUkon); } }, ukol.ukon.cisloPolozky))),
        pojisteni && (react_1.default.createElement(utils_2.SubjektBody, null,
            react_1.default.createElement(utils_2.StyledSpan, null, "Term\u00EDn pro dolo\u017Een\u00ED dokladu o poji\u0161t\u011Bn\u00ED"),
            react_1.default.createElement(utils_2.StyledDiv, null, __1.dateStringToString((_g = (_f = ukol.udaje) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.atribut)))),
        (posudek || ukon) && (react_1.default.createElement(utils_2.SubjektBody, null,
            react_1.default.createElement(utils_2.StyledSpan, null,
                "Term\u00EDn pro ",
                posudek ? 'vyhotovení' : 'provedení'),
            react_1.default.createElement(utils_2.StyledDiv, null, __1.dateStringToString((_j = (_h = ukol.udaje) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.atribut)))),
        ukol.infoPolozka && (react_1.default.createElement(utils_2.SubjektBody, null,
            react_1.default.createElement(utils_2.StyledSpan, null, "Informace"),
            react_1.default.createElement(utils_2.StyledDiv, null, ukol.infoPolozka))),
        ((_k = ukol.stav) === null || _k === void 0 ? void 0 : _k.id) === __1.StavUkolu.Dokonceno && (react_1.default.createElement(utils_2.SubjektBody, null,
            react_1.default.createElement(utils_2.StyledSpan, null, "Vy\u0159\u00EDdil"),
            react_1.default.createElement(utils_2.StyledDiv, null,
                react_1.default.createElement("div", null, utils_1.getJmenoNazevAutora(ukol.userVyrizeni)),
                react_1.default.createElement("div", null, __1.formatDateTime(ukol.datumVyrizeni || null))))),
        !pojisteni && !posudek && !ukon ? react_1.default.createElement(UdalostDetailPage_1.default, { udalost: ukol }) : react_1.default.createElement("br", null),
        ((_l = ukol.stav) === null || _l === void 0 ? void 0 : _l.id) === __1.StavUkolu.Nedokonceno ? (react_1.default.createElement(utils_2.ButtonWrapper, null,
            react_1.default.createElement(__1.Button, { name: "zobrazeno", type: "button", primary: true, onClick: handleDokonceno, loading: isLoadingSave.value }, "Vz\u00EDt na v\u011Bdom\u00ED"))) : (react_1.default.createElement(utils_2.ButtonWrapper, null,
            react_1.default.createElement(__1.Button, { name: "zavrit", type: "button", primary: true, onClick: function () { return handleClose(); } }, "Zav\u0159\u00EDt")))))));
};
InfoDetailUkoluPage.defaultProps = {
    ukol: undefined,
    onClose: undefined,
    sendingZobrazeno: true,
};
exports.default = InfoDetailUkoluPage;
